import React, { useEffect, useState } from "react";
import { Table, Space, Tooltip, Select, Modal, message } from "antd";
import { EditOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../../../firebase-config";
import FormPackage from "../FormPackage/FormPackage";
import ButtonComponent from "../../../CssComponents/ButtonComponent/ButtonComponent";
import styles from "../../../../styles/LmsList.module.css";
import arLogo from "../../../../logo.webp";

function ListPackage() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [filterType, setFilterType] = useState("all");
  const fetchPackages = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "lms_package"));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPackages(data);
    } catch (error) {
      console.error("Error fetching Packages:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPackages();
  }, []);

  const handleCreatePackage = () => {
    setInitialValues({});
    setShowForm(true);
  };

  const handleEditPackage = (packageItem) => {
    setInitialValues(packageItem);
    setShowForm(true);
  };

  // Add delete handler
  const handleDeletePackage = async (packageId) => {
    Modal.confirm({
      title: "Are you sure you want to delete this package?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          await deleteDoc(doc(db, "lms_package", packageId));
          message.success("Package deleted successfully");
          setPackages((prev) => prev.filter((p) => p.id !== packageId));
        } catch (error) {
          console.error("Error deleting package:", error);
          message.error("Failed to delete package: " + error.message);
        }
      },
    });
  };

  const columns = [
    {
      title: "Banner",
      dataIndex: "packageBanner",
      key: "packageBanner",
      render: (url) => (
        <img
          src={url || arLogo}
          alt="Package Banner"
          style={{ width: 60, height: 40, objectFit: "cover", borderRadius: 4 }}
        />
      ),
    },
    {
      title: "Package Name",
      dataIndex: "packageName",
      key: "packageName",
      render: (text) => text || "Untitled Package",
    },
    {
      title: "Description",
      dataIndex: "packageDescription",
      key: "packageDescription",
      render: (text) => text || "No description available.",
    },
    {
      title: "Type",
      dataIndex: "packageType",
      key: "packageType",
      render: (type) =>
        type === "digital" || type === "package_dp"
          ? "Digital"
          : type === "live" || type === "package_lc"
          ? "Live"
          : "-",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit">
            <EditOutlined onClick={() => handleEditPackage(record)} />
          </Tooltip>
          <Tooltip title="View">
            <EyeOutlined onClick={() => handleEditPackage(record)} />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined
              onClick={() => handleDeletePackage(record.id)}
              style={{ color: "red" }}
            />
          </Tooltip>
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "packageStatus",
      key: "packageStatus",
      render: (status) => (
        <span className={` ${status ? "text-green-500" : "text-red-500"}`}>
          {status ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  // Filtering logic
  const filteredPackages =
    filterType === "all"
      ? packages
      : packages.filter((pkg) =>
          filterType === "digital"
            ? pkg.packageType === "digital" || pkg.packageType === "package_dp"
            : pkg.packageType === "live" || pkg.packageType === "package_lc"
        );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.heading}>Available Packages</div>
        <ButtonComponent
          onClick={handleCreatePackage}
          buttonText={"Create New Package"}
        />
      </div>
      {/* Filter Dropdown */}
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          alignItems: "center",
          gap: 12,
        }}
      >
        <span>Filter by Type:</span>
        <Select
          value={filterType}
          onChange={setFilterType}
          style={{ width: 160 }}
          options={[
            { label: "All", value: "all" },
            { label: "Digital", value: "digital" },
            { label: "Live", value: "live" },
          ]}
        />
      </div>
      <Table
        dataSource={filteredPackages}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 8 }}
      />
      {showForm && (
        <FormPackage
          initialValues={initialValues}
          fetchPackages={fetchPackages}
          setInitialValues={setInitialValues}
          showForm={showForm}
          onClose={() => setShowForm(false)}
        />
      )}
    </div>
  );
}

export default ListPackage;
